import type { PartnershipStatus, Supplier } from '../types/supplyChain';

const PARTNER_STATUSES: readonly PartnershipStatus[] = [
  'strategic-agreement',
  'loi',
  'mou',
];

export function isDatacratePartner(supplier: Supplier | undefined | null): boolean {
  const status = supplier?.partnership?.status;
  return status != null && PARTNER_STATUSES.includes(status);
}

export function partnershipBadgeLabel(supplier: Supplier | undefined | null): string | null {
  if (!isDatacratePartner(supplier)) return null;
  switch (supplier?.partnership?.status) {
    case 'strategic-agreement':
      return 'Datacrate partner';
    case 'loi':
      return 'LOI in place';
    case 'mou':
      return 'MOU in place';
    default:
      return null;
  }
}

export function primarySupplierEmail(supplier: Supplier | undefined | null): string | undefined {
  if (!supplier?.contacts?.length) return undefined;
  const sales = supplier.contacts.find(c => c.role === 'sales' && c.email);
  if (sales?.email) return sales.email;
  const general = supplier.contacts.find(c => c.email);
  return general?.email;
}
